var map = {
	"./template-1/common/navigation-menu": "app/styles/client/templates/template-1/common/navigation-menu",
	"./template-10/common/navigation-menu": "app/styles/client/templates/template-10/common/navigation-menu",
	"./template-11/common/navigation-menu": "app/styles/client/templates/template-11/common/navigation-menu",
	"./template-2/common/navigation-menu": "app/styles/client/templates/template-2/common/navigation-menu",
	"./template-3/common/navigation-menu": "app/styles/client/templates/template-3/common/navigation-menu",
	"./template-4/common/navigation-menu": "app/styles/client/templates/template-4/common/navigation-menu",
	"./template-5/common/navigation-menu": "app/styles/client/templates/template-5/common/navigation-menu",
	"./template-6/common/navigation-menu": "app/styles/client/templates/template-6/common/navigation-menu",
	"./template-7/common/navigation-menu": "app/styles/client/templates/template-7/common/navigation-menu",
	"./template-8/common/navigation-menu": "app/styles/client/templates/template-8/common/navigation-menu",
	"./template-9/common/navigation-menu": "app/styles/client/templates/template-9/common/navigation-menu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6894;